import styled from 'styled-components';

export const DropdownContainer = styled.div`
  width: ${({ theme }) => theme.width.full};

  & span {
    width: 0;
  }
`;
